export default __webpack_public_path__ + "static/media/sms_slide10.01ea60a3.jpg";